import styled from 'styled-components'

export const StyledMenu = styled.nav`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  background: ${() => localStorage.getItem('menubg')};
  transform: ${({ open }) => open ? 'translateX(0)' : 'translateX(-100%)'};
  height: 100vh;
  text-align: left;
  position: fixed;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  top: 0;
  left: 0;
  border-right: 1px solid #444;
  transition: transform 0.3s ease-in-out;
  z-index: 999;
  @media (max-width: ${() => '600'}) {
      width: 100%;
    }
  a {
    font-size: 1rem;
    text-transform: uppercase;
    font-weight: '500';
    letter-spacing: 0.2rem;
    color: ${() => localStorage.getItem('menutxt')};
    text-decoration: none;
    transition: color 0.3s linear;
    @media (max-width: ${() => '600'}) {
      font-size: 0.5rem;
      text-align: center;
    }
  }
`